import { Component, OnInit } from '@angular/core';
import { UserService } from '../../layout/service/user.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-simulation-history',
    imports: [
        CommonModule
    ],
    styles: [`
        .history-card {
            background: #f8fafc;
            border-radius: 1.1rem;
            box-shadow: 0 2px 8px 0 rgba(31,38,135,0.07);
            border: 1px solid #dbeafe;
            padding: 1.5rem 1.2rem 1.2rem 1.2rem;
            margin-bottom: 1.5rem;
            transition: box-shadow 0.2s, transform 0.2s;
        }
        .history-card:hover {
            box-shadow: 0 4px 16px 0 rgba(31,38,135,0.13);
            transform: translateY(-2px) scale(1.01);
        }
        .history-title {
            font-size: 1.2rem;
            font-weight: 700;
            color: #2563eb;
            margin-bottom: 0.3rem;
        }
        .history-desc {
            color: #64748b;
            margin-bottom: 0.7rem;
            font-size: 1rem;
        }
        .history-date {
            font-size: 0.95rem;
            color: #334155;
            margin-bottom: 0.5rem;
        }
        .history-osce-list {
            margin-top: 0.7rem;
        }
        .history-osce-item {
            background: #e0e7ff;
            border-radius: 0.6rem;
            padding: 0.6rem 1rem;
            margin-bottom: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1.2rem;
        }
        .osce-info {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }
        .osce-title {
            font-weight: 600;
            color: #1e293b;
            font-size: 1.05rem;
        }
        .osce-cat {
            font-size: 0.93rem;
            color: #2563eb;
            margin-top: 0.1rem;
            margin-left: 0;
        }
        .osce-score {
            font-size: 1.1rem;
            font-weight: 700;
            background: #e0f7ec;
            border-radius: 0.5rem;
            padding: 0.18rem 1.1rem;
            min-width: 48px;
            text-align: center;
            margin-left: 1.2rem;
            box-shadow: 0 1px 4px 0 rgba(31, 38, 135, 0.06);
            display: flex;
            align-items: center;
            gap: 0.3rem;
        }
        .osce-score.green {
            color: #22c55e;
            background: #e0f7ec;
        }
        .osce-score.yellow {
            color: #f59e42;
            background: #fef9c3;
        }
        .osce-score.red {
            color: #ef4444;
            background: #fee2e2;
        }
        .history-avg-score {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 0.4rem;
            margin-top: 0.7rem;
            margin-bottom: 0.7rem;
        }
        .history-crown {
            font-size: 1.5rem;
            color: #fbbf24;
        }
        .history-avg-score-value {
            font-size: 2.5rem;
            font-weight: 800;
            background: #fff7ed;
            border-radius: 0.5rem;
            padding: 0.15rem 1.1rem;
            /* Warna default, akan diubah dengan ngClass */
        }
        .history-avg-score-value.green {
            color: #22c55e;
            background: #e0f7ec;
        }
        .history-avg-score-value.yellow {
            color: #f59e42;
            background: #fef9c3;
        }
        .history-avg-score-value.red {
            color: #ef4444;
            background: #fee2e2;
        }
    `],
    template: `
        <div class="grid grid-cols-12 gap-8">
            <div class="col-span-12">
                <ng-container *ngIf="forms && forms.length > 0; else noHistoryTpl">
                    <!-- TAMPILAN JIKA ADA CODE (GROUP BY PESERTA) -->
                    <ng-container *ngIf="hasCode; else defaultHistoryTpl">
                        <div *ngFor="let form of forms" class="history-card">
                            <div class="history-title">{{ form.name }}</div>
                            <div class="history-desc" [innerHTML]="form.description"></div>
                            <div class="history-date">
                                Selesai pada:
                                <span *ngIf="form.start_time">{{ form.start_time | date: 'medium' }}</span>
                            </div>
                            <div class="mt-4">
                                <table class="min-w-full border text-sm">
                                    <thead>
                                        <tr>
                                            <th class="border px-2 py-1 text-left">Nama Peserta</th>
                                            <th *ngFor="let osce of form.osce" class="border px-2 py-1 text-left">{{ osce.TITLE }}</th>
                                            <th class="border px-2 py-1 text-left">Rata-rata</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let participant of participants">
                                            <td class="border px-2 py-1">{{ participant.name }}</td>
                                            <ng-container *ngFor="let osce of form.osce">
                                                <td class="border px-2 py-1">
                                                    <span class="osce-score"
                                                        [ngClass]="getScoreColorClass(getParticipantOsceScore(form, participant, osce))">
                                                        {{ getParticipantOsceScore(form, participant, osce) }}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <td class="border px-2 py-1">
                                                <span class="history-avg-score-value"
                                                    [ngClass]="getScoreColorClass(getParticipantAverageScore(form, participant))"
                                                    style="font-size: 1rem; font-weight: 800; border-radius: 0.5rem; padding: 0.15rem 1.1rem;">
                                                    {{ getParticipantAverageScore(form, participant) }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                    <!-- TAMPILAN DEFAULT (JIKA TIDAK ADA CODE) -->
                    <ng-template #defaultHistoryTpl>
                        <div *ngFor="let form of forms" class="history-card">
                            <div class="flex justify-between items-center">
                                <div>
                                    <div class="history-title">{{ form.name }}</div>
                                    <div class="history-desc" [innerHTML]="form.description"></div>
                                </div>
                                <div class="history-avg-score" *ngIf="form.osce && form.osce.length > 0 && form.scores">
                                    <span class="history-crown"><i class="pi pi-crown" style="font-size: 2.5rem"></i></span>
                                    <span class="history-avg-score-value"
                                        [ngClass]="getScoreColorClass(getAverageScore(form))"
                                        style="font-size: 2.5rem;">
                                        {{ getAverageScore(form) }}
                                    </span>
                                </div>
                            </div>
                            <div class="history-date">
                                Selesai pada:
                                <span *ngIf="form.start_time">{{ form.start_time | date: 'medium' }}</span>
                            </div>
                            <div class="history-osce-list">
                                <div *ngFor="let osce of form.osce; let idx = index" class="history-osce-item">
                                    <div class="osce-info">
                                        <span class="osce-title">{{ osce.TITLE }}</span>
                                        <span class="osce-cat">{{ osce.KATEGORI }}</span>
                                    </div>
                                    <span class="osce-score"
                                        [ngClass]="getScoreColorClass(getOsceScore(form, osce))">
                                        {{ getOsceScore(form, osce) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-template #noHistoryTpl>
                    <div class="text-gray-400 italic text-center mt-8">Tidak ada riwayat simulasi yang telah selesai.</div>
                </ng-template>
            </div>
        </div>
    `
})
export class SimulationHistory implements OnInit {
    user: any;
    forms: any[] = [];
    code: string|null = '';
    participants: any[] = [];
    hasCode: boolean = false;

    constructor(
        private userService: UserService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.code = this.route.snapshot.paramMap.get('code');
        this.hasCode = !!this.code;
        const user = localStorage.getItem('user');
        if (user) {
            try {
                this.user = JSON.parse(user) || {};
            } catch {
                this.user = {};
            }
        }
        this.loadHistory();
    }

    loadHistory() {
        if (this.code && this.code !== '') {
            // Jika ada code di route param, filter berdasarkan code
            this.userService.getPackageSimulation().then((res) => {
                this.getParticipant().then(() => {
                    this.forms = res.data || [];

                    this.forms = this.forms.filter((form: any) => (form.code + '').trim() === (this.code + '').trim());
                    const promises = this.forms.map((form: any) => {
                        // Perbaikan parsing osce_id
                        if (typeof form.osce_id === 'string') {
                            try {
                                form.osce = JSON.parse(form.osce_id);
                            } catch {
                                form.osce = [];
                            }
                        } else if (Array.isArray(form.osce_id)) {
                            form.osce = form.osce_id;
                        } else {
                            form.osce = [];
                        }
                        return this.userService.simulationUserAnswer({package_id: form.id})
                            .then((res: any) => {
                                form.scores = res.data || [];

                                // Tambahkan nama peserta ke setiap skor
                                form.scores.forEach((score: any) => {
                                    const participant = this.participants.find((p: any) => p.user_id === score.USER_ID);
                                    score.name = participant ? participant.name : '';
                                });
                                return form;
                            });
                    });
                    Promise.all(promises).then((formsWithScores) => {
                        this.forms = formsWithScores;
                    });
                });
            });
        } else {
            // Jika tidak ada code di route param, tampilkan semua finished
            this.userService.getPackageSimulation().then((res) => {
                this.forms = res.data || [];
                const promises = this.forms.map((form: any) => {
                    // Perbaikan parsing osce_id
                    if (typeof form.osce_id === 'string') {
                        try {
                            form.osce = JSON.parse(form.osce_id);
                        } catch {
                            form.osce = [];
                        }
                    } else if (Array.isArray(form.osce_id)) {
                        form.osce = form.osce_id;
                    } else {
                        form.osce = [];
                    }
                    return this.userService.simulationUserAnswer({user_id: this.user.ID_USER, package_id: form.id})
                        .then((res: any) => {
                            form.scores = res.data || [];
                            return form;
                        });
                });
                Promise.all(promises).then((formsWithScores) => {
                    this.forms = formsWithScores;

                });
            });
        }
    }

    getOsceScore(form: any, osce: any): number|string {
        if (!form.scores) return '-';
        const found = form.scores.find((s: any) => s.ID_OSCE == osce.ID_OSCE);
        return found ? found.SKOR : '-';
    }

    getScoreColorClass(score: any): string {
        const val = parseFloat(score);
        if (isNaN(val)) return '';
        if (val >= 90) return 'green';
        if (val >= 70) return 'yellow';
        return 'red';
    }

    getAverageScore(form: any): number {
        if (!form.scores || !Array.isArray(form.scores) || form.scores.length === 0) return 0;
        const total = form.scores.reduce((sum: number, r: any) => sum + (parseFloat(r.SKOR) || 0), 0);
        return Math.round((total / form.scores.length) * 100) / 100;
    }

    getParticipant(): Promise<any> {
        const payload = {
            code: this.code
        };
        return this.userService
            .simulationParticipant(payload)
            .then((response) => {
                this.participants = response.data;
            })
            .catch((error) => {

            });
    }

    // Ambil skor OSCE untuk peserta tertentu
    getParticipantOsceScore(form: any, participant: any, osce: any): number|string {
        if (!form.scores) return '-';
        const found = form.scores.find((s: any) => s.USER_ID === participant.user_id && s.ID_OSCE == osce.ID_OSCE);
        return found ? found.SKOR : '-';
    }

    // Ambil rata-rata skor untuk peserta tertentu
    getParticipantAverageScore(form: any, participant: any): number {
        if (!form.scores) return 0;
        const userScores = form.scores.filter((s: any) => s.USER_ID === participant.user_id);
        if (!userScores.length) return 0;
        const total = userScores.reduce((sum: number, r: any) => sum + (parseFloat(r.SKOR) || 0), 0);
        return Math.round((total / userScores.length) * 100) / 100;
    }
}
